
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
  import {
    activityInviteFrienddataList,

  } from "@/api/live"
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate,
    }
  })

  export default class ProductList extends Vue {
    private keywords = ''
    private state = null
    private statelist = [
      {value:null,label:'全部'},
      {value:1,label:'进行中'},
      {value:2,label:'已完成'},
      {value:0,label:'未完成'},
    ]
    private tablelist:any = []
    private tableloading = false
    private total = 0
    private pageSize = 10
    private pageNo = 1
    private mounted () {
      this.gettablelist()
      
    }



    private exportfile(){
      let url = location.origin + '/pc/activityInviteFriend/dataExport'
      url += '?ActivityInviteFriendId=' + this.$route.query.Id
      url += '&Keywords=' + encodeURIComponent(this.keywords)
      url += '&InviteState=' + (this.state==null?'':this.state)
      window.open(url)
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let res:any = await activityInviteFrienddataList({
          Keywords:this.keywords,
          ActivityInviteFriendId:this.$route.query.Id,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize,
          InviteState:this.state
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private doSearch(){
      this.changePage(1)
    }
    private clearSearch(){
      this.keywords = ''
      this.changePage(1)
    }
  }
